module.exports = __webpack_public_path__ + "static/media/meeting_guide_app.0ec85ce5.png";